<template>
  <div>
    <section>
      <b-card
        class="my-50 admin-table--no-pagination"
        no-body
      >
        <Table
          :data="allEmails"
          class="admin-table__data"
          :columns="emailsColumns"
          :is-loading="isLoading"
          type-of-table="emails"
          :enable-pagination="false"
          :enable-sort="false"
        />
      </b-card>
    </section>
  </div>
</template>

<script>
import Table from '@/components/Table.vue'
import {
  computed,
  onMounted,
  ref,
} from '@vue/composition-api'
import store from '@/store'
import translation from '@/mixins/translate'

export default {
  components: {
    Table,
  },
  setup() {
    const emailsColumns = [
      {
        label: translation.methods.$tk('ClientPortal.Admin.Email.Id'),
        field: 'id',
        type: Number,
      },
      {
        label: translation.methods.$tk('ClientPortal.Admin.Email.Name'),
        field: 'name',
        type: String,
      },
      {
        field: 'actions',
        sortable: false,
      },
    ]
    const allEmails = computed(() => store.getters.allEmails)
    const isLoading = ref(false)

    onMounted(async () => {
      isLoading.value = true
      await store.dispatch('getEmails')
      isLoading.value = false
    })

    return {
      allEmails,
      isLoading,
      emailsColumns,
    }
  },
}
</script>
